import React from 'react';
import { Spacer } from '../../components';
import MemberSignUpCard from '../dash/MemberSignUpCard';

const CustomUrlCard: React.FC<React.PropsWithChildren> = () => {
  return (
    <>
      <Spacer height='xxs' />
      <MemberSignUpCard />
    </>
  );
};

export default CustomUrlCard;
